import GroupsIcon from '@mui/icons-material/Groups'
import Setting from '../components/icons/Setting'
import Volumnn from '../components/icons/Voulumn'
import Person from '../components/icons/Person'
import Credit from '../components/icons/Credit'
import Mqtt from '../components/icons/Mqtt'
import GridOverview from '../components/icons/GridOveriew'
import Statistic from '../components/icons/Statistic'
import Tethering from '../components/icons/Tethering'
import Book from '../components/icons/Book'

export const permissionDefine = {
    ADMIN: 'Admin',
    USER: 'User',
}

const menus = (role, auth) => {
    const checkRead = auth?.Permissions.filter(
        (item) => item.action === 'read' || item.name === 'superAdmin',
    )

    const AllowRead = (name) => {
        const allow = checkRead.filter((item) => item.name === name)
        return !!allow[0]
    }

    const menu = [
        {
            name: 'Overview',
            icon: <GroupsIcon />,
            route: '/',
            permission: [permissionDefine.USER],
        },
    ]

    const adminMenu = [
        {
            name: 'Organizations',
            icon: (
                <svg
                    viewBox='0 0 24 24'
                    width={20}
                    height={20}
                    fill='white'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path d='M11.62 9.21c.23.18.37.47.37.78v12c0 .55-.45 1-1 1h-9c-.56 0-1-.45-1-1v-10c0-.47.32-.88.78-.98l9-2c.29-.07.6 0 .84.19Zm-8.63 3.58v8.19h7v-9.76l-7 1.55Z' />
                    <path d='M22.64 1.23c.22.18.35.47.35.76v20c0 .55-.45 1-1 1h-11c-.56 0-1-.45-1-1v-18c0-.49.34-.9.82-.99l11-2c.29-.06.59.02.81.21Zm-10.65 3.6v16.16h9V3.18l-9 1.63Z' />
                    <path d='M13.5 7.5V6h2v1.5h-2Z' />
                    <path d='M13.5 12v-1.5h2V12h-2Z' />
                    <path d='M13.5 16.5V15h2v1.5h-2Z' />
                    <path d='M4 15.5V14h2v1.5H4Z' />
                    <path d='M4 19.5V18h2v1.5H4Z' />
                    <path d='M17.5 7.5V6h2v1.5h-2Z' />
                    <path d='M17.5 12v-1.5h2V12h-2Z' />
                    <path d='M17.5 16.5V15h2v1.5h-2Z' />
                    <path d='M7 15.5V14h2v1.5H7Z' />
                    <path d='M7 19.5V18h2v1.5H7Z' />
                </svg>
            ),
            route: '/organizations',
            ref2: '/',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('organization'),
        },
        {
            name: 'Devices',
            icon: <Setting />,
            route: '/devices',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('device'),
        },

        {
            name: 'Notifications',
            icon: <Volumnn />,
            route: '/notifications',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('notification'),
        },
        {
            name: 'User Management',
            icon: <Person />,
            route: '/user-management',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('user management'),
        },

        {
            name: 'Role & Permission',
            icon: <Credit />,
            route: '/role-permission',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('role permission'),
        },
        {
            name: 'MQTT Broker',
            icon: <Mqtt />,
            route: '/mqtt-broker',
            permission: [permissionDefine.ADMIN],
            allow: AllowRead('mqtt broker'),
        },
    ]

    const userMenu = [
        {
            name: 'Overview',
            icon: <GridOverview />,
            route: '/',
            permission: [permissionDefine.USER],
            allow: AllowRead('dashboard'),
        },
        {
            name: 'Device IoT',
            icon: <Tethering />,
            route: '/device-iot',
            permission: [permissionDefine.USER],
            allow: AllowRead('device'),
        },
        {
            name: 'Graph Trend',
            icon: <Statistic />,
            route: '/graph-trend',

            permission: [permissionDefine.USER],
            allow: AllowRead('graph'),
        },
        {
            name: 'Report',
            icon: <Book sx={{ width: '20px', height: '20px' }} />,
            route: '/report',
            permission: [permissionDefine.USER],
            allow: AllowRead('report'),
        },
    ]

    if (role === 1) {
        return adminMenu
    } else if (role === 2) {
        return userMenu
    } else {
        return menu
    }
}

export default menus
